import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { ProductRes } from 'features/products/types/products.types'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate, useUserRoles } from 'shared/hooks'
import { AuthContext, StoreSettingsContext } from 'store'

export const useFetchProduct = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)
	const storeCtx = useContext(StoreSettingsContext)
	const { isUser } = useUserRoles()

	const { data: product, isSuccess: isProductSuccess } = useQuery<ProductRes>({
		queryKey: queryKeys.products.detail(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.product(params.id as string)),
		enabled: !!auth.accessToken && (isUser || !!storeCtx?.storeSettings?.vat_rate_choices?.length)
	})

	return {
		product,
		isProductSuccess
	}
}
